import type { OnboardingPage } from '../generated/gql-types';

/** Aligns with backend `normalizeContractType` (ContractTemplate). */
export function normalizeContractTypeForMatch(
  value: string | undefined | null,
): string {
  const t = String(value ?? '')
    .trim()
    .replace(/\s+/g, '_');
  if (!t) {
    return 'PRIMARY';
  }
  return t.toUpperCase();
}

export type ContractStatusRowForPick = {
  contractId: string;
  contractType?: string | null;
};

export function pickContractStatusForOnboarding(
  statuses: ContractStatusRowForPick[],
  pageContractType: string | undefined | null,
  enableMultiContractOnboarding: boolean,
): ContractStatusRowForPick | undefined {
  if (!statuses.length) {
    return undefined;
  }
  if (!enableMultiContractOnboarding) {
    return statuses[0];
  }
  const desired = normalizeContractTypeForMatch(pageContractType);
  const matches = statuses.filter(
    (s) => normalizeContractTypeForMatch(s.contractType) === desired,
  );
  if (!matches.length) {
    return statuses[0];
  }
  return [...matches].sort((a, b) =>
    a.contractId.localeCompare(b.contractId),
  )[0];
}

export function getDesiredContractTypeForOnboardingPage(
  page: OnboardingPage,
): string | undefined {
  const extended = page as OnboardingPage & { contractType?: string | null };
  if (
    extended.contractType != null &&
    String(extended.contractType).trim() !== ''
  ) {
    return String(extended.contractType);
  }
  const signQuestion = page.questions?.find((q) => q.key === 'signContract');
  const meta = signQuestion?.metadata;
  if (meta && typeof meta === 'object' && !Array.isArray(meta)) {
    const ct = (meta as Record<string, unknown>).contractType;
    if (typeof ct === 'string' && ct.trim() !== '') {
      return ct;
    }
  }
  return undefined;
}
